import { configureStore } from "@reduxjs/toolkit";
import uiReducer from "./uiSlice";
import cookieReducer from "./cookieSlice";
import propertiesReducer from "./propertiesSlice";

const store = configureStore({
  reducer: {
    ui: uiReducer,
    cookie: cookieReducer,
    properties: propertiesReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
